import AxiosProvider from '../../providers/AxiosProvider'

export const getSKUFilters = async () => {
  const beepAxios = AxiosProvider.getBeepAxios()
  const reqUri = '/products/filters'
  let resp

  try {
    resp = await beepAxios.get(reqUri)
  } catch (err) {
    throw new Error(err.response.data)
  }

  return resp.data
}
